//Node Modules
import axios from 'axios'

const BASE_URL = '/tracking'

export function trackDownload(format: string, type: string, locale: string, alias: string, cfr: string, docset: string, page: string): Promise<void> {
  return axios.get<void>(
    `${BASE_URL}/${format}/${type}/${alias}/${cfr}/${docset}/target/${page}`,
    {
      params: {
        locale
      }
    }
  ).then(response => response.data)
}

export function trackDocsetNavigation(alias:string, cfr:string, page: string, anchor:string, referrer:string, title:string): Promise<void> {
  return axios.get<void>(
    `${BASE_URL}/docsetNavigation/${alias}/${cfr}/target/${page}`,
    {
      params: {
        anchor,
        referrer,
        title
      }
    }
  ).then(response => response.data)
}

export function trackCDCNavigation(alias:string, cfr:string, docset:string, page: string, anchor:string, referrer:string, title:string): Promise<void> {
  return axios.get<void>(
    `${BASE_URL}/cdcNavigation/${alias}/${cfr}/${docset}/target/${page}`,
    {
      params: {
        anchor,
        referrer,
        title
      }
    }
  ).then(response => response.data)
}

export function trackDocsetResource(alias:string, cfr:string, resourceID: string, page: string, referrer:string, title:string, locale:string, anchor?: string): Promise<void> {
  return axios.get<void>(
    `${BASE_URL}/docsetResource/${alias}/${cfr}/resource/${resourceID}/target/${page}`,
    {
      params: {
        locale,
        anchor,
        referrer,
        title
      }
    }
  ).then(response => response.data)
}

export function trackCDCResource(alias:string, cfr:string, docset: string, resourceID: string, page: string, referrer:string, title:string, locale:string, anchor?: string): Promise<void> {
  return axios.get<void>(
    `${BASE_URL}/cdcResource/${alias}/${cfr}/docset/${docset}/resource/${resourceID}/target/${page}`,
    {
      params: {
        locale,
        anchor,
        referrer,
        title
      }
    }
  ).then(response => response.data)
}